const QuickLink = ({ icon, text, onClick }) => {
  return (
    <div className="quick-link d-flex flex-column justify-content-center align-items-center mx-2 cursor-pointer">
      <se-icon size="medium" color="secondary" onClick={onClick} aria-label={text || "quick-link-action"}>
        {icon}
      </se-icon>
      <p className="quick-link-text">{text}</p>
    </div>
  );
};

export default QuickLink;